import React, { useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha';

const GoogleCaptcha = ({setCaptchaValue}) => {
    

    const handleCaptchaChange = (value) => {
        console.log("Captcha value:", value);
        setCaptchaValue(value); // Send this value to backend for verification
    };

    return (
        <>
            <ReCAPTCHA
                sitekey="6Lc-RAcUAAAAAKNozSCY8aGH2sQRF5Lc_8MgDI22"
                onChange={handleCaptchaChange}
            />
        </>
    )
}

export default GoogleCaptcha